/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
// @flow
import type { Element } from 'react';

import React from 'react';
import classNames from 'classnames';
import { HAZARD_EDITION } from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import { HAZARD_EDITION_VALUES } from '@hbrisk/sp3-risk-model-support/models/app/attributes/values/index.js';
import SelectMenu from '#components/pages/Models/Model/sections/support/forms/SelectMenu/index.js';

const options = [
  { text: 'Alaska 2007', value: HAZARD_EDITION_VALUES.AK_2007 },
  { text: 'Hawaii 1998', value: HAZARD_EDITION_VALUES.HI_1998 },
  { text: 'Conterminous US 2008', value: HAZARD_EDITION_VALUES.US_2008 },
  { text: 'Conterminous US 2014', value: HAZARD_EDITION_VALUES.US_2014 },
  { text: 'Conterminous US 2018', value: HAZARD_EDITION_VALUES.US_2018 },
];

const items = options.map(option => ({
  id: option.value,
  value: option.value,
  name: option.text,
}));

type Props = {
  form: string,
  editions: string[],
};

const HazardEditionSelectMenu = ({ form, editions }: Props): Element<typeof SelectMenu> => (
  <SelectMenu
    form={form}
    items={items.filter(item => editions.includes(item.value))}
    id={HAZARD_EDITION}
    name={HAZARD_EDITION}
    className={classNames('custom-select', 'hazard-edition-select')}
  />
);

export default HazardEditionSelectMenu;
